"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const date_picker_1 = __importDefault(require("components/cosmos/date-picker"));
const InputLabel_1 = __importDefault(require("components/cosmos/InputLabel"));
const translationContext_1 = require("configs/translationContext");
const Date_1 = __importStar(require("helpers/Date"));
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const minimumDate = '1969-12-31';
const getYesterday = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split('T')[0];
};
const mapStateToProps = (stores) => ({
    releaseDateTimeISO: stores.DrippingFormStore.releaseDateTimeISO
});
const DrippingByDate = ({ releaseDateTimeISO }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const yesterday = getYesterday();
    const dateValue = releaseDateTimeISO
        ? Date_1.default.format(releaseDateTimeISO, Date_1.shortFormatDate)
        : '';
    const handleDateChange = (datePickerEvent) => {
        const dateTimeISO = datePickerEvent.selectedDates[0].toISOString();
        stores_1.DrippingFormStore.setReleaseDateTimeValue(dateTimeISO);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center _bg-gray-100 _rounded _mt-3 _p-3", children: [(0, jsx_runtime_1.jsx)(InputLabel_1.default, { className: "_mr-3", children: t('dripping_2.new.release_and_expiration.release.items.specific_date.release_day') }), (0, jsx_runtime_1.jsx)(date_picker_1.default, { placeholder: "dripping.date.select_date", date: dateValue, disabledDates: [{ from: minimumDate, to: yesterday }], "data-test": "liberationDatePicker", onChange: handleDateChange })] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingByDate);
